import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { Link } from 'app/components/link';
import { SummaryInformationRow } from 'app/components/summary-information-row';
import { i18n } from 'app/i18n';

interface Props {
    deliveryMethod: string;
    deliveryMethodNote: string;
    linkToMoreInformation?: string;
}

export const DeliveryInformation: FunctionComponent<Props> = (props) => {
    const { deliveryMethod, deliveryMethodNote, linkToMoreInformation } = props;

    return (
        <SummaryInformationRow
            label={deliveryMethod}
            note={{
                label: deliveryMethodNote,
                value: linkToMoreInformation && (
                    <Link variant="paragraph3" maxBreakpoint={Breakpoint.TABLET} href={linkToMoreInformation}>
                        {i18n.page.summary.deliveryInformation.linkToDeliveryPage}
                    </Link>
                ),
            }}
        />
    );
};
